import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PageContainerComponent} from '@components/pages/page-container/page-container.component';
import {GridContainerComponent} from '@components/pages/grid-container/grid-container.component';
import {WidgetsModule} from '@components/pages/widgets/widgets.module';
import {KtdGridModule} from '@katoid/angular-grid-layout';
import {NgSelectModule} from '@ng-select/ng-select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PagesRoutingModule} from '@components/pages/pages-routing.module';
import {TranslateModule} from '@ngx-translate/core';
import {BrowserModule} from '@angular/platform-browser';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {SharedModule} from '@shared/shared.module';
import {ChartsModule} from '@components/pages/charts/charts.module';
import {PageComponentsModule} from '@components/pages/page-components/page-components.module';
import {
  MachinePageHeaderComponent
} from '@components/pages/page-container/header/machine-page-header/machine-page-header.component';
import {
  PageHeaderLogoAndNameComponent
} from '@components/pages/page-container/header/page-header-logo-and-name/page-header-logo-and-name.component';
import {StatusEventPageModule} from '@components/pages/page-components/status-event-page/status-event-page.module';
import {
  UserDefinedPageContainerComponent
} from '@components/pages/page-container/user-defined-page-container/user-defined-page-container.component';
import {
  StatusEventPageContainerComponent
} from '@components/pages/page-container/status-event-page/status-event-page-container.component';
import {FramePageContainerComponent} from '@components/pages/page-container/frame-page/frame-page-container.component';
import {
  InteractiveDataAnalysisContainerComponent
} from '@components/pages/page-container/interactive-data-analysis/interactive-data-analysis-container.component';
import {
  TableauPageContainerComponent
} from '@components/pages/page-container/tableau-page/tableau-page-container.component';
import {FormPageContainerComponent} from '@components/pages/page-container/form-page/form-page-container.component';
import {
  BucketBrowserContainerComponent
} from '@components/pages/page-container/bucket-browser-page/bucket-browser-container.component';
import {
  CloneUserDefinedPageComponent
} from '@components/pages/page-container/user-defined-page-container/modals/clone-user-defined-page/clone-user-defined-page.component';
import {
  StatusEventGroupPageContainerComponent
} from '@components/pages/page-container/status-event-group-page-container/status-event-group-page-container.component';
import {
  StatusEventGroupPageModule
} from '@components/pages/page-components/status-event-group-page/status-event-group-page.module';


@NgModule({
  declarations: [
    PageContainerComponent,
    GridContainerComponent,
    MachinePageHeaderComponent,
    PageHeaderLogoAndNameComponent,
    StatusEventPageContainerComponent,
    StatusEventGroupPageContainerComponent,
    FramePageContainerComponent,
    InteractiveDataAnalysisContainerComponent,
    UserDefinedPageContainerComponent,
    TableauPageContainerComponent,
    FormPageContainerComponent,
    BucketBrowserContainerComponent,
    CloneUserDefinedPageComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    KtdGridModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    PagesRoutingModule,
    WidgetsModule,
    ChartsModule,
    PageComponentsModule,
    SharedModule,
    StatusEventPageModule,
    StatusEventGroupPageModule,
  ]
})
export class PagesModule {
}
